import React from 'react';
import { Link } from 'react-router-dom';
export function Header() {
  const navItems = ['Soluciones', 'Recursos', 'Danke Hub IA', 'Precios', 'Soporte'];
  return <header className="fixed top-0 left-0 right-0 z-50 px-6 py-4 flex items-center justify-between bg-transparent" data-id="element-181">
      {/* Logo */}
      <Link to="/" className="flex items-center gap-2 cursor-pointer group" data-id="element-182">
        <img src="https://cdn.magicpatterns.com/uploads/6der9p7cTuhPYDgtJnKRAY/Group_1448.svg" alt="Danke Consulting" className="h-8 group-hover:scale-105 transition-transform duration-300" data-id="element-183" />
      </Link>

      {/* Desktop Navigation */}
      <nav className="hidden md:flex items-center gap-8" data-id="element-184">
        {navItems.map(item => <a key={item} href="#" className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors relative group" data-id="element-185">
            {item}
            <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gray-900 transition-all duration-300 group-hover:w-full" data-id="element-186" />
          </a>)}
      </nav>

      {/* Auth Buttons */}
      <div className="flex items-center gap-4" data-id="element-187">
        <Link to="/login" className="hidden sm:block text-sm font-medium text-gray-700 hover:text-gray-900 px-4 py-2 rounded-full border border-transparent hover:bg-white/50 transition-all duration-300" data-id="element-188">
          Iniciar sesiónes
        </Link>
        <Link to="/register" className="text-sm font-medium text-white bg-gray-900 px-5 py-2.5 rounded-full hover:scale-105 hover:shadow-lg transition-all duration-300 active:scale-95" data-id="element-189">
          Comenzar
        </Link>
      </div>
    </header>;
}